import { z } from 'zod';

export const TraceAgentNameSchema = z.enum(['neo', 'deep_active_probe']);

export type TraceAgentName = z.infer<typeof TraceAgentNameSchema>;

export const TRACE_AGENT_NAMES = TraceAgentNameSchema.options;

export const TraceAgentNameFilterSchema = z.union([
  z.string(),
  z.array(z.string()),
]);

export type TraceAgentNameFilter = z.infer<typeof TraceAgentNameFilterSchema>;
